import React from 'react';


const INRShow = ({ amount }) => {
  const numericAmount = typeof amount === 'number' || 'string' ? amount : 0;
  const formattedAmount = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount);

  return (
    <span>{formattedAmount}</span>
  );
};


export default INRShow;